@let showStepper = $showStepper();
@if (showStepper) {
  <kendo-stepper
    class="form-stepper"
    stepType="full"
    [steps]="$formSteps()"
    [linear]="false"
    [currentStep]="$pageIndex()"
    (activate)="activateStep($event)"
    (currentStepChange)="navigateToPage($event)" />
}
@if ($isLoading()) {
  <kendo-skeleton />
} @else {
  <ng-content select="[form-response-survey]">
    <!-- form survey from subcomponent, use as:
          <ng-container form-response-survey> <content /> </ng-container> -->
  </ng-content>
}
@if (showStepper) {
  <kendo-stacklayout class="stepper-controls" [gap]="5" [align]="{ horizontal: 'center', vertical: 'middle' }">
    <button type="button" kendoButton themeColor="secondary" [svgIcon]="arrowLeftIcon" [disabled]="!$showPrevious()" (click)="prevPage()">
      Previous Page
    </button>
    <button type="button" kendoButton themeColor="secondary" [svgIcon]="arrowRightIcon" [disabled]="!$showNext()" (click)="nextPage()">
      Next Page
    </button>
  </kendo-stacklayout>
}
